import { useSearchParamActions } from "./useSearchParamActions";

export function useRemoveMultipleParams() {
  const { removeSearchParams } = useSearchParamActions();

  return [removeSearchParams];
}
